import axios from 'axios';
const BASE_URL = 'https://loyalty.bom.asia';

const API_BASE_URL = `${BASE_URL}/api/miniApp/checkin/banners`;

// Upload banner images
export const uploadBanners = async (bannerImages, token) => {
  try {
    const formData = new FormData();
    
    // Add multiple banner images to FormData
    if (Array.isArray(bannerImages)) {
      bannerImages.forEach((image, index) => {
        formData.append('bannerImages', image);
      });
    } else {
      formData.append('bannerImages', bannerImages);
    }

    const response = await axios.post(`${API_BASE_URL}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('❌ Upload banners error:', error);
    throw error;
  }
};

// Get all banners
export const getAllBanners = async (token) => {
  try {
    const response = await axios.get(API_BASE_URL, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    
    // Ensure we return an array based on actual API response format
    if (response.data && response.data.success && response.data.data && Array.isArray(response.data.data.banners)) {
      return response.data.data.banners;
    } else if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data && Array.isArray(response.data.data)) {
      return response.data.data;
    } else if (response.data && Array.isArray(response.data.banners)) {
      return response.data.banners;
    } else {
      console.warn('⚠️ Unexpected API response format:', response.data);
      return [];
    }
  } catch (error) {
    console.error('❌ Get all banners error:', error);
    throw error;
  }
};

// Get banner by ID
export const getBannerById = async (bannerId, token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${bannerId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('❌ Get banner by ID error:', error);
    throw error;
  }
};

// Update banner
export const updateBanner = async (bannerId, bannerData, token) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/${bannerId}`, bannerData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('❌ Update banner error:', error);
    throw error;
  }
};

// Delete banner
export const deleteBanner = async (bannerId, token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/${bannerId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('❌ Delete banner error:', error);
    throw error;
  }
};

// Helper function to get token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('authToken') || localStorage.getItem('token');
};

// Wrapper functions with automatic token injection
export const bannerApi = {
  // Upload banners with automatic token
  upload: async (bannerImages) => {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }
    return uploadBanners(bannerImages, token);
  },

  // Get all banners with automatic token
  getAll: async () => {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }
    try {
      const result = await getAllBanners(token);
      // Ensure we always return an array
      return Array.isArray(result) ? result : [];
    } catch (error) {
      console.error('❌ Banner API getAll error:', error);
      return [];
    }
  },

  // Get banner by ID with automatic token
  getById: async (bannerId) => {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }
    return getBannerById(bannerId, token);
  },

  // Update banner with automatic token
  update: async (bannerId, bannerData) => {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }
    return updateBanner(bannerId, bannerData, token);
  },

  // Delete banner with automatic token
  delete: async (bannerId) => {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }
    return deleteBanner(bannerId, token);
  }
};

export default bannerApi;
